import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import ScrollTable from './ScrollTable';

const AlertsContent = styled.div`
                        background: #F5DADA;
                        width: 100%;
						min-height: 299px;
						padding: 20px 40px;

						@media (max-width: 991px) {
							padding: 20px 15px;
						}

						.slider-title {
							font-weight: bold;
							font-size: 15px;
							display: block;
							width: 100%;
							text-align: center;
							color: #D9001C;
						}

`;


function Alerts(props) {
	const activities = useSelector(state => state.activities);

	let acts = activities.filter(activity =>
		activity.status !== 'completed' && new Date() > new Date(activity.finish)
	);

	let activityItems = acts.splice(0, 5);

	return (
		<AlertsContent>
			<div className="row mb-4">
				<div className="col-12"><span className="slider-title">Alerts</span></div>
			</div>
			<ScrollTable activities={activityItems} />
		</AlertsContent>
	);
}

export default Alerts;